<script setup lang="ts">
import { Link } from "@inertiajs/vue3"
import { ArrowRightIcon } from "lucide-vue-next"

import StatusPing from "@/components/custom/StatusPing.vue"

const props = withDefaults(
  defineProps<{
    price?: string
    name: string
    type?: string
    situational?: boolean
    status?: "pending" | "approved" | "rejected"
    path?: string
    color?: string
  }>(),
  {
    color: "#93b0fb",
  },
)
</script>

<template>
  <Link
    :href="path"
    class="border-border group relative flex flex-col justify-between overflow-hidden rounded-sm border p-4.5 transition-all duration-200 hover:border-[#cbd2ee] hover:shadow-[0_8px_24px_-16px_rgba(15,23,42,0.18)]"
  >
    <div
      class="absolute top-0 left-0 min-h-60 w-1"
      :style="{ backgroundColor: color }"
    />

    <StatusPing v-if="status" :status="status" class="absolute top-4 right-4" />
    <div
      v-if="$slots.icon"
      class="text-primary flex size-10 items-center justify-center rounded-sm bg-[#EEF1FB]"
    >
      <slot name="icon" class="size-9" />
    </div>
    <p v-if="price" class="text-primary mt-2 text-3xl">
      {{ price }}<span class="text-base">€</span>
    </p>
    <Link
      :href="path"
      class="text-primary mt-4 flex w-full items-center justify-between gap-1 text-left text-sm font-bold whitespace-pre-line group-hover:underline"
    >
      {{ name }}
      <ArrowRightIcon class="size-4 shrink-0" />
    </Link>
    <p v-if="type" class="text-muted-foreground text-left text-sm">
      {{ type }}
    </p>
  </Link>
</template>
